import React, {FC} from 'react';

/** 代理合作机制中文正文（i18n：壳组件按语言选择 zh/en 内容组件；h1 在壳 hero，正文从 h2 起，
 * 语义标签排版由 Prose（.v3-prose）提供）。2026-09-16 重写：由老文档站迁移的极简版扩充为
 * 「计划介绍 + 奖励规则 + 加入步骤」三段式，文案对齐当前内容本地化生成定位（不再局限于
 * "图片翻译"），奖励比例/示例数字与老版本保持一致，未新增未经业务确认的政策细节。 */
const ZhContent: FC = () => {
  return (
    <>
      <section>
        <h2>什么是代理合作机制</h2>
        <p>
          象寄为了服务更多有跨境内容本地化需求的卖家，同时回馈把象寄推荐给身边卖家朋友的老用户，特别推出了代理合作机制。
          您只需要把专属邀请链接分享给正在做跨境电商、需要商品图片生成、视频本地化或主图/详情图生成服务的朋友，
          对方注册并成为象寄用户后，其后续每一笔付费，您都能获得一份永久有效的推荐奖励——不设时间上限，也不需要重复邀请。
        </p>
        <div className="v3-note">
          <p>
            代理合作机制面向所有象寄用户开放，没有额外的资质门槛或申请审核，注册即可获得属于自己的邀请链接，随时可以开始推荐。
          </p>
        </div>
      </section>
      <section>
        <h2>奖励规则</h2>
        <p>好友通过您的邀请链接注册并完成付费后，您可以在以下两种奖励方式中任选其一，二者互斥、按笔结算：</p>
        <ul>
          <li>
            <strong>15% 额度奖励</strong>：按好友的付费金额折算为等值的象寄服务额度，可直接用于自己账户的图片生成、
            视频本地化或详情页内容生成，适合本身也在持续使用象寄服务的卖家；
          </li>
          <li>
            <strong>10% 现金奖励</strong>：以现金形式直接发放，适合更看重即时收益的推荐人。
          </li>
        </ul>
        <p>
          举个例子：象寄用户"老王"的好朋友"小丽"开始做跨境电商，需要商品图片生成与详情页内容服务，
          老王觉得象寄效果好、价格低，于是把邀请链接推荐给了小丽。小丽注册后购买了一万张图片额度， 老王就可以选择{' '}
          <strong>15% 的额度奖励</strong>（即 1500 张图片额度），或者 <strong>10% 的现金奖励</strong>。
        </p>
      </section>
      <section>
        <h2>如何成为代理</h2>
        <h3>1. 获得自己的专属邀请链接</h3>
        <p>登录象寄工作台后，在个人中心即可找到您的专属邀请链接，链接与您的账户永久绑定。</p>
        <img
          alt="获取邀请链接界面"
          decoding="async"
          loading="lazy"
          src="https://www.xiangjifanyi.com/doc/assets/images/proxyLink-b19297b66a83019a38381eedec4e6a15.jpg"
        />
        <h3>2. 把邀请链接发送给身边有出海需求的卖家朋友</h3>
        <p>对方需要使用手机号完成注册，注册时不需要额外填写您的邀请码，系统会自动完成绑定关系。</p>
        <h3>3. 在"用户列表"中随时查看邀请客户与奖励进展</h3>
        <p>好友注册成功后，您可以在工作台的"用户列表"中看到全部已邀请的客户，跟踪对方的付费与奖励发放情况。</p>
        <img
          alt="邀请的客户列表界面"
          decoding="async"
          loading="lazy"
          src="https://www.xiangjifanyi.com/doc/assets/images/customerList-6a1f51325e636766f7270d307f93568b.jpg"
        />
      </section>
    </>
  );
};

export default ZhContent;
